import type { StockBalance } from '@trackeat/shared';

type StockValuation = Pick<
  StockBalance,
  'onHandValue' | 'averageUnitCost' | 'valueCurrency' | 'unvaluedOnHandQty'
>;

/**
 * Returns the canonical carrying cost only when the whole on-hand balance is
 * valued. A latest purchase price is not a safe fallback for produced,
 * transferred, or partially unvalued stock.
 */
export function projectedCarryingCost(
  balance: StockValuation,
): { unitCost: number | null; currency: string } {
  const currency = balance.valueCurrency?.trim().toUpperCase() ?? '';
  const complete = (
    balance.onHandValue != null
    && balance.averageUnitCost != null
    && Number.isFinite(balance.averageUnitCost)
    && balance.averageUnitCost >= 0
    && balance.unvaluedOnHandQty <= 0.000_000_001
    && /^[A-Z]{3}$/.test(currency)
  );
  return complete
    ? { unitCost: balance.averageUnitCost, currency }
    : { unitCost: null, currency: 'EUR' };
}
